import { createEffect } from 'effector'
import type { GenericApiResponse } from '../../interfaces/generic'
import type {
  EmailCaptureConfirmParams,
  MarketingEmailSubscribeParams,
} from './index.h'

export type { EmailCaptureConfirmParams, MarketingEmailSubscribeParams }

// *
// * base API effects (CAPI, email capture / leads, …)
// *
export const base = {
  trackEventFx: createEffect<Record<string, unknown>, void>(),
  emailSubscribeFx: createEffect<
    MarketingEmailSubscribeParams,
    void,
    GenericApiResponse<Error>
  >(),
  // GET /api/web/email-capture/confirm?token=
  confirmEmailCaptureFx: createEffect<
    EmailCaptureConfirmParams,
    void,
    GenericApiResponse<Error>
  >(),
}
